import { jsx as _jsx } from "react/jsx-runtime";
import MuiChip from '@mui/material/Chip';
import * as React from 'react';
import { useMergeRefs, useOverflow } from '../hooks';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { makeEnum, withVersion } from '../utils';
export * from './chip-group';
export * from './birthday-chip';
const sizes = ['small', 'medium'];
export const ChipSize = makeEnum(...sizes);
const ChipImpl = React.forwardRef((props, ref) => {
    const { color = 'default', cursor, maxWidth = 150, size = 'small', label, tooltipText, ...muiProps } = props;
    const innerRef = useMergeRefs(ref);
    const labelRef = React.useRef(null);
    const { textOverflow } = useOverflow(labelRef, props.label);
    const colorMain = useColor(color, 'main');
    const colorHover = useColor(color, 'hovered');
    return (_jsx(Tooltip, { title: tooltipText ?? props.label, bypass: tooltipText ? false : !textOverflow, children: _jsx(MuiChip, { ref: innerRef, label: typeof label === 'string' ? (_jsx(Label, { color: color, ref: labelRef, children: label })) : (label), "data-role": "chip", size: size, ...muiProps, color: "default", sx: {
                backgroundColor: colorMain,
                cursor,
                borderRadius: 1,
                '.MuiChip-label': label
                    ? {
                        boxSizing: 'content-box',
                        maxWidth
                    }
                    : {
                        paddingLeft: 0
                    },
                ...(muiProps.onClick && {
                    '&:hover': { backgroundColor: colorHover }
                }),
                ...muiProps.sx
            } }) }));
});
export const Chip = withVersion(ChipImpl, '1.0.0');
Chip.displayName = 'Chip';
const Label = React.forwardRef((props, ref) => {
    const colorContrastText = useColor(props.color, 'contrastText');
    return (_jsx(Typography, { component: "span", color: colorContrastText, variant: "inherit", ref: ref, overflow: "hidden", textOverflow: "ellipsis", display: "block", children: props.children }));
});
function useColor(color, token) {
    switch (color) {
        case 'default':
        case 'active':
        case 'inactive':
        case 'primary':
        case 'info':
        case 'error':
        case 'warning':
        case 'success':
            return `components.chip.${color}.${token}`;
        case 'app':
        case 'mail':
        case 'message':
        case 'digital-post':
        case 'letter':
            return `components.chip.additional-colour-coding.${color}.${token}`;
    }
}
export const chipStyle = {
    MuiChip: {
        styleOverrides: {
            sizeSmall: ({ theme }) => ({
                fontSize: theme.palette.components?.chip?.small?.fontSize,
                fontWeight: theme.palette.components?.chip?.small?.fontWeight
            }),
            sizeMedium: ({ theme }) => ({
                fontSize: theme.palette.components?.chip?.medium?.fontSize,
                fontWeight: theme.palette.components?.chip?.medium?.fontWeight
            })
        }
    }
};
